<template>
  <div>
    <div class="controller-wrapper">
      <slot name="openButton">
        <el-button
          v-if="!readOnly"
          style="display: block"
          type="primary"
          @click="openPop"
        >
          <i class="el-icon-plus"></i>
          {{ title }}
        </el-button>
      </slot>

      <slot name="tagShow">
        <el-table border :data="selectedList" size="medium" class="m-t-20">
          <el-table-column type="index" label="序号" width="60" />
          <el-table-column
            prop="companyName"
            label="供应商名称"
            min-width="180"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="contactName"
            label="联系人"
            align="center"
            min-width="100"
          />
          <el-table-column
            prop="contactTel"
            label="联系电话"
            align="center"
            min-width="100"
          />
          <el-table-column
            v-if="isCombo"
            prop="comboCompanyNames"
            label="联合体其他成员"
            show-overflow-tooltip
            align="center"
            min-width="120"
          >
            <template slot-scope="{ row }">
              <span>
                {{
                  row.comboCompanyNames ? row.comboCompanyNames.join(',') : '-'
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="!readOnly"
            prop="operator"
            label="操作"
            min-width="140"
            align="center"
          >
            <template slot-scope="{ row, $index }">
              <el-button
                v-if="isCombo"
                type="text"
                @click="addCombo(row, $index)"
              >
                添加联合体
              </el-button>
              <el-button
                type="text"
                class="text-danger"
                @click="closeTag($index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </slot>
    </div>

    <!-----选择供应商抽屉------->
    <select-supplier-drawer
      :visible.sync="visible"
      :selected="selectedList"
      :is-wl="isWl"
      :is-single="isSingle"
      :is-agency="isAgency"
      :is-allow-use-srm="isAllowUseSrm"
      :purchase-company-id="purchaseCompanyId"
      :disabled-array="normalizeDisabledList"
      @confirmed="handleDrawerConfirm"
    />

    <!-----添加联合体弹窗-------->
    <add-combo-dialog ref="addComboDialog" @setComboList="setComboList" />
  </div>
</template>

<script>
import SelectSupplierDrawer from '@/components/common/SelectSupplierDrawer/SelectSupplierDrawer'
import AddComboDialog from '@/components/common/SelectSupplierDrawer/AddComboDialog'
import { isFunction } from 'element-ui/src/utils/types'
import { cloneDeep } from 'lodash'

export default {
  components: {
    SelectSupplierDrawer,
    AddComboDialog
  },

  model: {
    prop: 'selected',
    event: 'change'
  },

  props: {
    title: {
      type: String,
      default: '添加供应商'
    },
    selected: {
      type: Array,
      default: () => []
    },

    normalizeIn: {
      type: Function,
      default: list => list
    },

    normalizeOut: {
      type: Function,
      default: list => list
    },

    disabledArray: {
      type: Array,
      default: () => []
    },

    isCombo: {
      type: Boolean,
      default: false
    },

    tableKey: {
      type: String,
      default: 'id'
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    // 是否是五菱
    isWl: {
      type: Boolean,
      default: false
    },

    // 是否单选
    isSingle: {
      type: Boolean,
      default: false
    },

    isAgency: {
      type: Boolean,
      default: false
    },

    // 采购人公司id
    purchaseCompanyId: {
      type: [String, Number],
      default: ''
    },

    // 是否授权代理机构使用供应商库
    isAllowUseSrm: {
      type: Number,
      default: 0
    },

    // 是否授权代理机构使用供应商库
    isPageFrom: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false,
      selectedList: []
    }
  },

  computed: {
    normalizeDisabledList() {
      if (isFunction(this.normalizeIn)) {
        return this.normalizeIn(this.disabledArray)
      } else {
        return this.disabledArray
      }
    }
  },

  watch: {
    selected: {
      handler: function(value) {
        if (value) this.selectedList = cloneDeep(this.normalizeIn(value))
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    openPop() {
      if (
        this.isPageFrom === 'InviteBidForm' &&
        this.isAgency &&
        !this.purchaseCompanyId
      ) {
        this.$message.warning('请选择委托项目')
        return false
      }
      this.visible = true
    },

    closeTag(index) {
      this.selectedList.splice(index, 1)
      if (isFunction(this.normalizeOut)) {
        this.$emit('change', this.normalizeOut(this.selectedList))
      } else {
        this.$emit('change', this.selectedList)
      }
    },

    handleDrawerConfirm(list) {
      this.selectedList = []
      this.selectedList = cloneDeep(list)
      let emitData = []
      if (isFunction(this.normalizeOut)) {
        emitData = this.normalizeOut(list)
      } else {
        emitData = list
      }
      emitData.forEach(el => {
        const item =
          (this.selected || []).find(
            k => k[this.tableKey] === el[this.tableKey]
          ) || {}
        el.comboCompanyNames = item.comboCompanyNames
      })
      this.$emit('change', emitData)
    },

    /**
     * 添加联合体
     */
    addCombo(data, index) {
      this.$refs.addComboDialog.open(data.comboCompanyNames, index)
    },

    /**
     * 设置联合体
     */
    setComboList(data) {
      const list = data.list || []
      const index = Number(data.index)
      const selectIndex = {
        ...this.selectedList[index],
        comboCompanyNames: list.map(el => el.name)
      }
      this.$set(this.selectedList, index, selectIndex)
      if (isFunction(this.normalizeOut)) {
        this.$emit('change', this.normalizeOut(this.selectedList))
      } else {
        this.$emit('change', this.selectedList)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table--medium th,
  .el-table--medium td {
    padding: 6px 0;
  }
}
</style>
